import api from 'api'

const updateMessageReader = async (conversationId: number) => {
  const response = await api.put(`/home/message_reader/${conversationId}`)
  return response.data
}

export default updateMessageReader
